// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('UpdateCompositeArticleResult')
export class UpdateCompositeArticleResult {
  @JsonProperty('finished', 'Boolean')
  public finished: boolean = undefined;
  @JsonProperty('updatedArticles', '[Number]')
  public updatedArticles: string[] = undefined;

}
